import React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import Card from '../../../ui/Card';
import { ReadMoreButton } from '../../../ui/ReadMoreButton';
import { PresentIcon } from '../../../ui/icons';
import * as styles from './costAndFeesModule.styles';

export const SpecialOfferBanner = () => {
  const specialOffers = useSelector(
    (state: RootReduxState) => state.currentListingDetails?.currentListing?.specialOffers,
  );

  if (!specialOffers || specialOffers.length === 0) return null;

  const offer = specialOffers[0];

  return (
    <Card variant="accent" size="md" className={styles.specialOfferCard}>
      <div className={styles.specialOfferHeading}>
        <PresentIcon />
        Special offer!
      </div>
      <div className={styles.specialOfferBody}>
        <ReadMoreButton
          content={offer.description}
          maxTruncatedLength={80}
          readMoreText="Read more"
          readLessText="Read less"
        />
      </div>
    </Card>
  );
};
